// src/lib/supabase.js

import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Missing Supabase environment variables. Using demo mode.');
}

// The data client keeps NO auth session: identity is the Lunexx JWT, and the
// email sign-in's Supabase Auth session lives in its own client
// (lib/supabaseAuth.js), so the auth.uid() RLS policies stay inert here.
export const supabase = createClient(
  supabaseUrl || 'https://demo.supabase.co',
  supabaseAnonKey || 'demo-key',
  { auth: { persistSession: false, autoRefreshToken: false, detectSessionInUrl: false } }
);

// Helper to check if we're in demo mode
export const isDemoMode = !supabaseUrl || !supabaseAnonKey;